import React, { useEffect, useState } from "react";
import EventRSVPForm from "./EventRSVPForm";
import Moment from "react-moment";
import "moment-timezone";
import { getEventBySlug } from "../../utils/api/helpers/event";
// import spacerSquare from "../../Common/_assets/img/placeholder/spacer_portrait_film.png";
// import shadowImage from "../../Common/_assets/img/bg/events-thumbmail-shadow.png";
// import fyseePlaceholder from "../../Common/_assets/img/placeholder/Netflix_FYSEE_placeholder.jpg";
// import fyseeSpacer from "../../Common/_assets/img/placeholder/emy_miniposter_placeholder.png";
import fysee25LogoWhite from "../../Common/_assets/img/fysee25/fysee25logo-white.png";
import iconCalendar from "../../Common/_assets/img/fysee25/icon-calendar.svg";
import iconClock from "../../Common/_assets/img/fysee25/icon-clock.svg";
import iconPin from "../../Common/_assets/img/fysee25/icon-pin.svg";
import { useParams } from "react-router-dom";

const EventDetail = () => {
	const { eventSlug } = useParams();

	const [startDate, setStartDate] = useState(null),
		// [startDateNum, setStartDateNum] = useState(null),
		[startTime, setStartTime] = useState(null),
		[eventTitle, setEventTitle] = useState(""),
		[eventDescription, setEventDescription] = useState(""),
		// [eventCategories, setEventCategories] = useState([]),
		[eventShows, setEventShows] = useState([]),
		[allowGuests, setAllowGuests] = useState(false),
		[emailDisabled, setEmailDisabled] = useState(false),
		[eventMediaSrc, setEventMediaSrc] = useState(null),
		[venueTimezone, setVenueTimezone] = useState(null),
		[venueName, setVenueName] = useState(null),
		// [venueAddress, setVenueAddress] = useState(null),
		[venueMapUrl, setVenueMapUrl] = useState(null),
		// [venueCity, setVenueCity] = useState(null),
		[guestThreshold, setGuestThreshold] = useState(0);

	const s3Url = "https://jwlfyc-public-us-east-1.s3.amazonaws.com/";

	useEffect(() => {
		let subscribed = true;
		if (subscribed) {
			Moment.globalTimezone = "America/Los_Angeles";
			Moment.globalLocale = "en-us";

			getEventBySlug(eventSlug).then((result) => {
				if (result.data) {
					setEventTitle(result.data.title);
					setEventDescription(result.data.description);
					setAllowGuests(result.data.allow_guests > 0);
					setEmailDisabled(result.data.email_disabled);
					// setEventCategories([]);
					setGuestThreshold(result.data.guest_threshold);
					setVenueName(result.data.venue_name);
					// setVenueAddress(result.data.venue_address);
					// setVenueCity(result.data.venue_city);
					setVenueTimezone(result.data.venue_timezone);
					setEventShows(result.data.shows);

					setVenueMapUrl(
						result.data.venue_name.split(" ").join("+") +
							"+" +
							result.data.venue_address.split(" ").join("+") +
							"+" +
							result.data.venue_city.split(" ").join("+") +
							"+" +
							result.data.venue_state +
							"+" +
							result.data.venue_zipcode,
					);

					if (Object.keys(result.data.shows).length === 1) {
						setEventMediaSrc(s3Url + result.data.filename);
					} else {
						setEventMediaSrc(fysee25LogoWhite);
					}

					const tempDateTime =
						result.data.start_date.split("T")[0] + "T12:00:00.000";
					setStartDate(tempDateTime);
					// setStartDateNum(
					// 	result.data.start_date.split("T")[0].split("-")[2],
					// );
					let hours =
						result.data.start_time.split(":")[0] +
						":" +
						result.data.start_time.split(":")[1];
					let hoursFormatted = tConvert(hours);
					setStartTime(hoursFormatted);
				}
			});
		}
		return () => (subscribed = false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [eventSlug]);

	const tConvert = (time) => {
		time = time
			.toString()
			.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

		if (time.length > 1) {
			time = time.slice(1);
			time[5] = +time[0] < 12 ? " AM" : " PM";
			time[0] = +time[0] % 12 || 12;
		}
		return time.join("");
	};

	return (
		<div className="width_ctrl px-3">
			<div className={"events-page-container nf-sans-cond"}>
				<div className={"events-page-nav"}>
					<a href={"/events"}>&#8592; All FYSEE LA Events</a>
				</div>
				<div className={"events-page-header"}>
					<div className={"events-page-header-title"}>
						<span>{eventTitle}</span>
					</div>
					<div className={"events-page-header-right"}>
						<div
							className={"events-page-header-img"}
							style={{
								padding:
									eventShows &&
									Object.keys(eventShows).length === 1
										? "0px"
										: "8px",
							}}
						>
							<img
								src={eventMediaSrc}
								alt={eventTitle}
								className={""}
							/>
						</div>
						{eventShows && Object.keys(eventShows).length > 1 ? (
							<div className={"events-page-header-shows"}>
								{eventShows.map((o, i) => {
									return (
										<span key={i} className="">
											{i > 0 ? ", " : ""} {o.title}
										</span>
									);
								})}
							</div>
						) : (
							<></>
						)}
					</div>
				</div>
				<div className={"events-page-content"}>
					<div
						className={"events-page-content-copy nf-sans"}
						dangerouslySetInnerHTML={{ __html: eventDescription }}
					/>
					<div className={"events-page-content-details"}>
						{startDate ? (
							<div className={"events-page-content-meta"}>
								<div className={"events-page-content-meta-row"}>
									<div
										className={
											"d-flex align-items-center events-page-content-meta-icon"
										}
									>
										<img
											src={iconCalendar}
											className={""}
											alt={"icon"}
										/>
									</div>
									<div className={"events-page-meta-value"}>
										<Moment format="dddd, MMM DD">
											{startDate}
										</Moment>
									</div>
								</div>
								<div className={"events-page-content-meta-row"}>
									<div
										className={
											"d-flex align-items-center events-page-content-meta-icon"
										}
									>
										<img
											src={iconClock}
											className={""}
											alt={"icon"}
										/>
									</div>
									<div className={"events-page-meta-value"}>
										{startTime} {venueTimezone}
									</div>
								</div>
								<div className={"events-page-content-meta-row"}>
									<div
										className={
											"d-flex align-items-center events-page-content-meta-icon"
										}
									>
										<img
											src={iconPin}
											className={""}
											alt={"icon"}
										/>
									</div>
									<div className={"events-page-meta-value"}>
										{venueName}
									</div>
								</div>
							</div>
						) : (
							<></>
						)}

						<div className={"events-page-content-map"}>
							<iframe
								title={venueName}
								src={
									"https://www.google.com/maps?q=" +
									venueMapUrl +
									"&output=embed"
								}
								width="100%"
								height="350"
								style={{ display: "block", border: 0 }}
								allowFullScreen="false"
								loading="lazy"
								referrerPolicy="no-referrer-when-downgrade"
							></iframe>
						</div>
					</div>
				</div>
				<div className={"events-page-rsvp-header"}>RSVP</div>
				<div
					className={
						"events-page-rsvp-form events-page-rsvp-form-container"
					}
				>
					{emailDisabled === 1 ? (
						<div
							className="text-center text-uppercase font-weight-bold my-3"
							style={{ fontSize: "1.5rem" }}
						>
							RSVPs to this event are closed.
						</div>
					) : (
						<EventRSVPForm
							allowGuests={allowGuests}
							event_slug={eventSlug}
							guestThreshold={guestThreshold}
							start_date={startDate}
							start_time={startTime}
							title={eventTitle}
						/>
					)}
				</div>
			</div>
			<div className="events__background" />
			<div className="events__background-gradient" />
		</div>
	);
};

export default EventDetail;
